/**
 * Created by ganlu on 03/11/2016.
 */
class ModalService {
    constructor() {
    }

    open(id) {
        $('body').addClass('no-scroll');
        $('#' + id).addClass('active');
    }

    close(id) {
        $('#' + id).removeClass('active');
        $('body').removeClass('no-scroll');
    }
}

export default ModalService;



// WEBPACK FOOTER //
// ./src/app/common/modal/modal.service.js